export const selectFeedbackId = store => store.feedback?.feedbackId;
export const selectFeedbackOption = store => store.feedback?.option;
export const selectFeedbackComment = store => store.feedback?.comment;

export const selectFeedbackDiscountPercentage = store => store.feedback?.discountPercentage || 0;

